// 判断当前运行环境，是否在微前端框架下
export const isMicroAppMode = () => window.__POWERED_BY_QIANKUN__

// 判断是否是在微前端环境下运行，如果是的话，走中台的逻辑，如果不是的话，走原逻辑
export const microAppSwitch = (isMicroFunction) => {
    return (rawFunction, option) => {
        if (isMicroAppMode()) {
            return isMicroFunction(option)
        } else {
            if (typeof rawFunction === 'function') {
                return rawFunction()
            }
        }
    }
}

// 页面跳转
export const navigate = (path) => {
    history.pushState("", document.title, path);
}

class Helper {

    getToken

    onUnloadMainSce

    onLoadMainSce

    previewScene

    versionSceneViewCallBack

    initAssign(props) {
        this.getToken = props.getToken
        this.onUnloadMainSce = props.onUnloadMainSce
        this.onLoadMainSce = props.onLoadMainSce
        this.previewScene = props.previewScene
        this.versionSceneViewCallBack = props.versionSceneViewCallBack
    }
}

export const helper = new Helper()

export function removeHash() {
    history.pushState('', document.title, window.location.pathname + window.location.search)
}